<template>
  <FormWrapper v-bind="formAttributes" class="form-generator" @submit="$emit('submitted', formData)">
    <fieldset v-for="(fieldset, index) in fieldsets" :key="index">
      <legend>{{ fieldset.legend }}</legend>
      <InputContainer
        v-for="(field, idx) in fieldset.inputs"
        :key="`input-${idx}`"
        :label="field.label"
        :id="field.inputAttributes.id"
        :type="field.inputAttributes.type"
        :has-value="formData[field.inputAttributes.name]"
      >
        <input
          v-if="field.tag == 'input'"
          v-model="formData[field.inputAttributes.name]"
          :class="`input-field__input input-field__input--${field.inputAttributes.type}`"
          v-bind="field.inputAttributes"
          @blur="handleBlur"
          @focus="handleFocus"
        >
        <select
          v-else-if="field.tag == 'select'"
          v-model="formData[field.inputAttributes.name]"
          :class="`input-field__input input-field__input--${field.inputAttributes.type}`"
          v-bind="field.inputAttributes"
        >
          <option
            v-for="(option, i) in field.options"
            :key="`option-${i}`"
            :value="option.value"
            v-bind="option.attributes ? option.attributes : null"
          >
            {{ option.label }}
          </option>
        </select>
        <component :is="field.tag" v-else>
          {{ field.content }}
        </component>
      </InputContainer>
    </fieldset>

      <slot />

    <Button
      title="Lookin' good"
      type="submit"
      button-color="light"
      button-background="dark"
      icon-right="arrow-right"
    />
  </FormWrapper>
</template>

<script>
import formFieldMixin from '@/mixins/formFieldMixin.js'

import FormWrapper from '@/components/form/FormWrapper'
import InputContainer from '@/components/form/InputContainer'
import Button from '@/components/partials/Button.vue'

/**
 * Use this component to generate a form by defining an object with form fields
 */

export default {
  inject: ['$validator'],
  components: {
    FormWrapper,
    InputContainer,
    Button
  },
  mixins: [formFieldMixin],
  props: {
    formAttributes: {
      type: Object,
      default: () => {}
    },
    fieldsets: {
      type: Array,
      default: () => []
    },
    prefill: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {...this.prefill}
    }
  }
}
</script>

<style lang="scss">
  .page-header + .form-generator {
    margin-top: rem(36);
  }
  .form-generator {
    fieldset {
      padding: 0 $padding;
    }
    padding-bottom: 2rem;
  }
</style>

<docs>
  ### Formdata is added to formData
  ```jsx
  const fields = [
    {
      legend: 'Legend',
      inputs: [
        {
          tag: 'input',
          inputAttributes: {
            name: 'firstname',
            id: 'firstname',
            placeholder: '',
            type: 'text'
          },
          label: 'label'
        },
        {
          tag: 'select',
          inputAttributes: {
            name: 'nationality',
            id: 'nationality',
            rules: 'required',
            type: 'select'
          },
          options:[
            {
              value: '',
              label: 'Option',
              attributes: {
                selected: 'selected',
                disabled: 'disabled'
              }
            },
            {
              value: 'option',
              label: 'option'
            },
            {
              value: 'option',
              label: 'option'
            }
          ],
          label: 'Select'
        }
      ]
    }
  ];
  <FormGenerator :fieldsets="fields" />
  ```
</docs>
